export default (agentState) => {
  switch (agentState) {
    case 'CallingCustomer':
      return 'Dialing';
    case 'PendingBusy':
      return 'Incoming Call';
    case 'Busy':
      return 'Connected';
    case 'Offline':
      return 'Offline';
    case 'waiting':
      return 'Awaiting Callback';
    case 'n/a':
      return 'Offline';
    case 'Authenticating':
      return 'Authenticating';
    case 'AuthFail':
      return 'AuthFail';
    default:
      return 'Available';
  }
};
